import { useMutation } from "@apollo/client";
import gql from "graphql-tag";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import { useHistory, useParams } from "react-router";
import { FormError } from "../components/form-error";
import { createReviewMutation, createReviewMutationVariables } from "../__generated__/createReviewMutation";

const CREATE_REVIEW_MUTATION = gql`
  mutation createReviewMutation($createReviewInput: CreateReviewInput!) {
    createReview(input: $createReviewInput) {
      ok
      error
    }
  }
`;

interface ICreateReviewForm {
  review: string;
  rating: number;
}

interface IParamsType {
  id: string;
}
export const WriteReview = () => {
  const [podcastId, setPodcastId] = useState("");
  const params = useParams<IParamsType>();
  const { register, handleSubmit, getValues, formState } = useForm<ICreateReviewForm>({
    mode: "onChange",
  });

  useEffect(() => {
    setPodcastId(params.id);
  }, [params.id]);

  const onSubmit = () => {
    const { review, rating } = getValues();
    if (!loading && podcastId) {
      createReviewMutation({
        variables: {
          createReviewInput: {
            review,
            rating: +rating,
            podcastId: +podcastId,
          },
        },
      });
    }
  };
  const history = useHistory();
  const onCompleted = (data: createReviewMutation) => {
    const {
      createReview: { ok },
    } = data;
    if (ok && podcastId) {
      history.push(`/podcast/${podcastId}`);
    }
  };
  const [createReviewMutation, { loading, data: createReviewMutationResult }] = useMutation<
    createReviewMutation,
    createReviewMutationVariables
  >(CREATE_REVIEW_MUTATION, {
    onCompleted,
  });
  return (
    <div className="h-screen bg-black text-white">
      <Helmet>
        <title>Write Review | Pocast</title>
      </Helmet>
      <div className="flex flex-col justify-center items-center text-center pt-10">
        <div className="w-full max-w-screen-sm px-5 text-center flex flex-col justify-between ">
          <div className="relative mb-24 mr-auto">
            <div className="text-left text-3xl tracking-wider leading-10 pb-1 text-purple-700">Edit Episode</div>
          </div>
          <form onSubmit={handleSubmit(onSubmit)} className="grid gap-3 mt-5  sm:w-96 sm:mx-auto  mb-5 z-10">
            <div className="text-left flex flex-col">
              <label className="mb-2 pl-2 font-bold text-white">Review</label>
              <input
                {...register("review", {
                  required: "Review is required",
                })}
                autoComplete="off"
                name="review"
                placeholder="Review"
                className="rounded-lg p-2 border-2 bg-transparent text-lg bg-gray-900 border-purple-200 transition-colors focus:outline-none focus:border-purple-700 mb-1"
              />
              {formState.errors.review?.message && <FormError errorMessage={formState.errors.review?.message} />}
            </div>
            <div className="text-left flex flex-col">
              <label className="mb-2 pl-2 font-bold text-white">Rating</label>
              <input
                {...register("rating", { required: "Rating is required", min: 0, max: 5 })}
                name="rating"
                type="number"
                placeholder="Rating"
                className="rounded-lg focus:outline-none focus:border-purple-700  p-2 border-2 bg-transparent text-lg border-purple-200 transition-colors sm:w-96 sm:mx-auto mb-1 bg-gray-900"
              />
              {formState.errors.rating?.message && <FormError errorMessage={formState.errors.rating?.message} />}
              {formState.errors.rating?.type === "min" && <FormError errorMessage="Rating should be equal or bigger than 0" />}
              {formState.errors.rating?.type === "max" && <FormError errorMessage="Rating should be equal or smaller than 5" />}
            </div>

            <button
              className={`flex justify-center py-2 rounded-lg font-bold text-white tracking-wider sm:w-96 sm:mx-auto focus:outline-none bg-purple-700 hover:bg-purple-800 transition delay-75 ${
                loading ? "select-none" : ""
              }`}
            >
              {loading ? "Loading ..." : "Create Review"}
            </button>
            {createReviewMutationResult?.createReview.error && <FormError errorMessage={createReviewMutationResult?.createReview.error} />}
          </form>
        </div>
      </div>
    </div>
  );
};
